import { useTranslation } from 'react-i18next';
import { GENDER_OPTIONS } from '@anytag/shared-constants';
import { useAllInfluencerCategoryOptions, useTranslateOptions } from '@anytag/shared-hooks';
import { SelectorField, TextSearchField } from '@anytag/shared-molecules';
import { Form } from '@anytag/shared-atoms';
import { TikTokCampaignInfluencersFilterFormKeys } from './schemaTypes';

export interface BasicFilterProps {
  onSubmit?: () => void;
}

export const BasicFilter = ({ onSubmit }: BasicFilterProps) => {
  const { t } = useTranslation();
  const genderOptions = useTranslateOptions(GENDER_OPTIONS);
  const { allInfluencerCategoryOptions } = useAllInfluencerCategoryOptions();

  return (
    <Form.Fields>
      <TextSearchField<TikTokCampaignInfluencersFilterFormKeys>
        name="keyword"
        onSubmit={onSubmit}
        placeholder={t<string>('Search.TikTokCampaignInfluencers')}
      />

      <SelectorField<TikTokCampaignInfluencersFilterFormKeys>
        name="genders"
        onSubmit={onSubmit}
        options={genderOptions}
        className="max-w-47"
        placeholder={t<string>('Selector.Gender')}
        multiple
      />

      <SelectorField<TikTokCampaignInfluencersFilterFormKeys>
        name="categoryIds"
        onSubmit={onSubmit}
        className="max-w-47"
        options={allInfluencerCategoryOptions}
        placeholder={t<string>('Selector.Categories')}
        multiple
      />
    </Form.Fields>
  );
};
